import {Component, OnInit} from '@angular/core';
import {UserService} from '../../services/user.service';
import {ActivatedRoute} from '@angular/router';
import {ShoppingCartService} from '../../services/shopping-cart.service';

@Component({
  selector: 'app-agreements',
  templateUrl: './agreements.component.html',
  styleUrls: ['./agreements.component.css']
})
export class AgreementsComponent implements OnInit {
  agreement_gdpr = false;
  agreement_terms = false;
  agreement_gdpr_link: String;
  agreement_terms_link: String;

  constructor(private userService: UserService,
              private route: ActivatedRoute,
              private shoppingCartService: ShoppingCartService) {
  }

  ngOnInit() {
    this.userService.fetchUser(this.route.snapshot.params['username'])
      .then(userDto => {
        this.agreement_gdpr_link = userDto.companyGdprURI;
        this.agreement_terms_link = userDto.companyTermsURI;
      });
    if (this.shoppingCartService.gdpr !== null &&
      this.shoppingCartService.gdpr !== undefined) {
      this.agreement_gdpr = this.shoppingCartService.gdpr;
    }
    if (this.shoppingCartService.terms !== null &&
      this.shoppingCartService.terms !== undefined) {
      this.agreement_terms = this.shoppingCartService.terms;
    }
  }

  onAgreement_gdpr_change(event: any) {
    this.agreement_gdpr ? this.shoppingCartService.gdpr = true
      : this.shoppingCartService.gdpr = false;
    this.shoppingCartService.saveBasket();

    (this.agreement_gdpr && this.agreement_terms) ?
      this.shoppingCartService.paymentAvailableEvent.emit(true) :
      this.shoppingCartService.paymentAvailableEvent.emit(false);
  }

  onAgreement_terms_change(event: any) {
    this.agreement_terms ? this.shoppingCartService.terms = true
      : this.shoppingCartService.terms = false;
    this.shoppingCartService.saveBasket();

    (this.agreement_gdpr && this.agreement_terms) ?
      this.shoppingCartService.paymentAvailableEvent.emit(true) :
      this.shoppingCartService.paymentAvailableEvent.emit(false);
  }

  showAgreementMessage() {
    return !(this.agreement_terms && this.agreement_gdpr);
  }
}
